// removed by extract-text-webpack-plugin
module.exports = {"flex":"layout__flex-1AULx","grey":"layout__grey-1A9sm","white":"layout__white-20FN7","blue":"layout__blue-1E33N","centred":"layout__centred-2ePTO","block":"layout__block-3Y9gx","container":"layout__container-5HQH5","headContainer":"layout__headContainer-fQL7M"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/layout/layout.css
// module id = 841
// module chunks = 0